export default __webpack_public_path__ + "static/4-2ef39c0049cfacf6525865b78e256c85.jpg";